import { render, staticRenderFns } from "./WorkIconTextBlock.vue?vue&type=template&id=15c3b866"
import script from "./WorkIconTextBlock.vue?vue&type=script&lang=js"
export * from "./WorkIconTextBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports